import { useEffect } from "react";
import { MapContainer, TileLayer, GeoJSON, useMap } from "react-leaflet";
import L from "leaflet";

function FitBounds({ data }) {
  const map = useMap();
  useEffect(() => {
    const layer = L.geoJSON(data);
    map.fitBounds(layer.getBounds(), { padding: [20,20] });
  }, [data, map]);
  return null;
}

export default function GeoJsonMap({ geom, height = 300 }) {
  // initial center/zoom is arbitrary, we’ll snap to bounds on ready
  return (
    <MapContainer
      center={[0, 0]}
      zoom={2}
      style={{ width: "100%", height }}
      scrollWheelZoom={false}
    >
      <TileLayer url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <GeoJSON data={geom} />
      <FitBounds data={geom}/>
    </MapContainer>
  );
}